export default __webpack_public_path__ + "static/media/cto_grant.12c13f5d.png";